










































































































































































import {BASE_URL, ENDPOINTS, get, MainApi} from '@/api/mainApi';
import Vue from 'vue';
import {Donation} from "@/interfaces/donation/donation";
import {PaymentMethod, Type} from "@/interfaces/economy/paymentMethod";
import {Snackbar} from "@/interfaces/presentation/snackbar";
import LabelMixin from '@/mixins/labelMixin';

export default Vue.extend({
    name: 'PaylinkView',
    mixins: [LabelMixin],
    data() {
      return {
        redirecting: false,
        loadingSwish: false,
        loadingCard: false,
        subPaymentMethods: {
          swish: Object as () => PaymentMethod,
          card: Object as () => PaymentMethod
        },
        paymentLoopBreakerThreshold: 10, // used as a breaker incase we get an infinite loop
        numberOfPaymentAttempts: 0,
        paymentCode: "",
        responseCode: 200,
        dialog: false,
        linkExpired: false,
        alreadyPaid: false,
        generalError: false,
      };
    },
    computed: {
      donation(): Donation {
        return this.$store.state.donation
      },
    },
    async mounted() {

      this.paymentCode = this.getPaymentCodeParam();
      this.responseCode = this.getResponseCodeParam();

      if (this.responseCode === 410) {
        this.linkExpired = true;
      }

      if (this.responseCode === 406) {
        this.alreadyPaid = true;
      }

      this.numberOfPaymentAttempts = 0;

      let paymentMethods: PaymentMethod[] = await get(ENDPOINTS.PAYMENT_METHODS);

      if (paymentMethods && paymentMethods.length) {
        let card: PaymentMethod | undefined = paymentMethods.find(pm => pm.type === Type.CARD);
        let swish: PaymentMethod | undefined = paymentMethods.find(pm => pm.type === Type.SWISH);
        if (card) {
          this.subPaymentMethods.card = card;
        } if (swish) {
          this.subPaymentMethods.swish = swish;
        }
      }
    },
    methods: {
      reset() {
        this.$emit('reset');
      },
      getPaymentCodeParam(): String | null {
        const queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("paymentCode")) {
          return urlParams.get("paymentCode")
        }
        return null
      },
      getResponseCodeParam(): number {
        const queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("responseCode")) {
          let responseCode: string | null = urlParams.get("responseCode");
          if (responseCode) {
            return Number.parseInt(responseCode)
          }
          else {
            return 400;
          }
        }
        return 400
      },
      getGiftCertificateUrl(): string {
        return BASE_URL + "/" + MainApi + "/" + ENDPOINTS.DONATIONS + '/' + this.donation.serialnumber + '/' + ENDPOINTS.CERTIFICATE + "?asImage=true"
      },
      goToPayment(paymentMethod: PaymentMethod) {

        // create digital payment
        if (paymentMethod.type == Type.SWISH)
        {
          this.loadingSwish = true;
        }
        if (paymentMethod.type == Type.CARD)
        {
          this.loadingCard = true;
        }
        get(ENDPOINTS.PAYMENTS + "/" + ENDPOINTS.TRANSACTIONS + "/" + ENDPOINTS.CODE, {
          paymentMethodId: paymentMethod.id,
          code: this.paymentCode,
        })
          .then(response => {
            if (response.redirectUrl) {
              location.href = response.redirectUrl;
            } else {
              if (this.numberOfPaymentAttempts > this.paymentLoopBreakerThreshold) {
                this.failed = true
                this.loadingCard = false
                this.loadingSwish = false
              } else {
                // the previous transaction might have failed and we need to create a new one
                this.numberOfPaymentAttempts++
                this.goToPayment(paymentMethod)
              }
            }
          })
          .catch(error => {
            console.error(error)
            this.loadingCard = false;
            this.loadingSwish = false;
            this.failed = true;
            let errorMsg = error.response.data.msg ? error.response.data.msg : this.$t('paylink.error.generalErrorLinkInvalid');

            let snackbar: Snackbar = {
              active: true,
              color: "error",
              text: errorMsg,
              timeout: 10000,
              action: null
            };
            this.$store.commit('setSnackbar', snackbar);
          })
      },
    },
  });
